import { render, staticRenderFns } from "./GrupoCompraCotacoes.vue?vue&type=template&id=7ef16132&"
import script from "./GrupoCompraCotacoes.vue?vue&type=script&lang=js&"
export * from "./GrupoCompraCotacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports